import { LockOpenVariantOutlineIcon } from './LockOpenVariantOutlineIcon';

/**
 * author: GreenTurtwig
 * id D3253799-FA57-4E62-967B-088FD6F1BF62
 * name lock-open-variant-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-variant-outline.svg
 * tags
 * - Lock 
 * - Home Automation 
 */
export const DecryptedVariantOutlineIcon = LockOpenVariantOutlineIcon;
export default DecryptedVariantOutlineIcon